import React, { Component } from "react"

export default class loading extends Component {
  render() {
    return (
      <>
        <div className="icon sun-shower">
          <div className="cloud"></div>
          <div className="sun">
            <div className="rays"></div>
          </div>
          <div className="rain"></div>
        </div>
        <h2 className="loading">Loading...</h2>
      </>
    )
  }
}
